import { render, staticRenderFns } from "./Intelligent-declaration.vue?vue&type=template&id=7f8035eb&scoped=true&"
import script from "./Intelligent-declaration.vue?vue&type=script&lang=js&"
export * from "./Intelligent-declaration.vue?vue&type=script&lang=js&"
import style0 from "./Intelligent-declaration.vue?vue&type=style&index=0&id=7f8035eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8035eb",
  null
  
)

export default component.exports